import React from 'react';
import { formatNumber } from '../../../../../../../core/utils/campaigns';
import { Chart, Geom, Axis, Tooltip, Coord } from 'bizcharts';
import DataSet from '@antv/data-set';

const BasketItemRingChart = ({ height, data, selectedBasketItemDimension }) => {
  const chartData = data.map((item) => ({
    value: item.value,
    quantity: item.quantity,
    total: item.total,
    color: item.color,
  }));

  const { DataView } = DataSet;
  const dv = new DataView();

  dv.source(chartData).transform({
    as: 'percent',
    type: 'percent',
    dimension: 'value',
    field: 'percent',
  });

  const cols = {
    percent: {
      formatter: function (val) {
        val = val * 100;
        return formatNumber(val) + '%';
      },
    },
    quantity: { formatter: (val) => val.toLocaleString() },
    total: {
      formatter: (val) => {
        return '$' + val.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
    },
  };

  return (
    <div>
      <Chart
        forceFit
        data={selectedBasketItemDimension === 'percent' ? dv : chartData}
        padding={'auto'}
        scale={cols}
        height={height / 1.1}
      >
        <Coord type="theta" radius={0.75} innerRadius={0.65} />
        {selectedBasketItemDimension === 'quantity' && <Axis name="quantity" />}
        {selectedBasketItemDimension === 'total' && <Axis name="total" />}

        <Tooltip showTitle={false} />

        <Geom
          color={[
            'value',
            (value) => {
              const item = chartData.find((el) => el.value === value);
              if (item && item.color) return item.color;
              else return 'black';
            },
          ]}
          position={
            selectedBasketItemDimension === 'percent'
              ? 'percent'
              : selectedBasketItemDimension === 'quantity'
                ? 'quantity'
                : 'total'
          }
          type="intervalStack"
        />
      </Chart>
    </div>
  );
};

export default BasketItemRingChart;
